import { FC } from "react";
import BasicLayout from "../layouts/BasicLayout";
import { Outlet } from "react-router-dom";
import HeaderComponent from "./views/HeaderComponent";

interface IHeaderRoute {
  loginData: any,
  permissions: any;
  sidebarsData:any;
}

export const headerRoutes = [{ id: 1, path: "", component: <HeaderComponent /> }];

const HeaderRoute: FC<IHeaderRoute> = ({ loginData, permissions,sidebarsData }) => {
  const data = loginData;

  return (
    <BasicLayout userData={data} permissions={permissions} sidebars={sidebarsData}>
      <div className="pt-0 pb-[58px]">
        <Outlet />
      </div>
    </BasicLayout>
  );
};

export default HeaderRoute;
